import { computed, makeObservable, observable } from 'mobx'
import { ICourtsAPIModel } from '../../common/api/api-models'
import { faker } from '@faker-js/faker'
import { getDistance, convertDistance } from 'geolib'
import _ from 'lodash'

export default class CourtEntity {
  constructor () {
    makeObservable(this, {
      id: observable,
      name: observable,
      courtType: observable,
      verified: observable,
      courts: observable,
      rating: observable,
      images: observable,
      latitude: observable,
      longitude: observable,
      distance: observable,
      address: observable,
      details: observable,
      reviewCount: observable,
      privacyType: observable,
      // placeId: observable,
      cost: observable,
      playLocation: observable,
      phone: observable,
      website: observable,
      mainImage: computed,
      renderedProps: computed
      // distanceAsString: computed
    })
  }

  getTypeNameFromCourtType (courtType: 'pickleball' | 'tennis' | 'badminton'): string {
    if (courtType === 'pickleball') {
      return 'Dedicated Pickleball'
    }
    if (courtType === 'tennis') {
      return 'Lined Tennis'
    }
    return 'Other'
  }

  fromAPIModel (apiModel: ICourtsAPIModel): void {
    this.id = apiModel.id.toString()
    this.name = apiModel.name
    this.courtType = apiModel.types
    this.verified = apiModel.verified ?? false
    this.courts = apiModel.num_courts
    this.rating = apiModel.rating
    this.images = []
    this.latitude = apiModel.location.coordinates[1]
    this.longitude = apiModel.location.coordinates[0]
    this.distance = apiModel.distance ?? 0
    this.address = apiModel.address
    this.details = apiModel.info
    this.hasLighting = apiModel.has_lighting ?? false
    this.hasMembership = apiModel.need_membership ?? false
    this.reviewCount = apiModel.num_reviews ?? 0
    this.cost = apiModel.cost
    this.playLocation = apiModel.play_location
    this.phone = apiModel.phone
    this.privacyType = apiModel.privacy_type
    this.placeId = apiModel.place_id ?? undefined
    if (apiModel.website !== null) {
      this.website = apiModel.website
    }

    if (apiModel.images !== undefined) {
      this.images = apiModel.images.map((image) => image.photo)
    }
  }

  get mainImage (): string {
    if (this.images.length > 0) {
      return this.images[0]
    }
    return ''
  }

  get renderedProps (): {playLocation: string, cost: string, hasLighting: string, courtType: string } {
    return {
      playLocation: _.startCase(_.toLower(this.playLocation)),
      courtType: this.getTypeNameFromCourtType(this.courtType as any),
      hasLighting: this.hasLighting ? 'TRUE' : 'FALSE',
      cost: this.cost.toUpperCase()
    }
  }

  distanceAsString (lat?: number, lng?: number): string {
    if (lat !== undefined && lng !== undefined) {
      const distance = getDistance({
        lat: this.latitude,
        lng: this.longitude
      }, {
        lat: lat,
        lng: lng
      })
      return `${convertDistance(distance, 'mi').toFixed(1)} mi`
    }

    return `${this.distance?.toFixed(1)} mi`
  }

  static mock (): CourtEntity {
    const courtEntity = new CourtEntity()
    courtEntity.id = faker.git.commitSha()
    courtEntity.name = faker.company.companyName()
    courtEntity.courtType = 'pickleball'
    courtEntity.verified = faker.datatype.boolean()
    courtEntity.courts = faker.datatype.number(20)
    courtEntity.rating = faker.datatype.number(5)
    courtEntity.images = [faker.image.imageUrl(200, 200, 'any', true), faker.image.imageUrl(200, 200, 'any', true), faker.image.imageUrl(200, 200, 'any', true)]
    courtEntity.latitude = parseFloat(faker.address.latitude())
    courtEntity.longitude = parseFloat(faker.address.longitude())
    courtEntity.distance = faker.datatype.float(1)
    courtEntity.address = faker.address.streetAddress()
    courtEntity.details = faker.lorem.paragraph()
    courtEntity.reviewCount = faker.datatype.number(100)
    courtEntity.cost = 'FREE'
    courtEntity.playLocation = 'Inside'
    courtEntity.phone = faker.phone.phoneNumber()
    courtEntity.website = faker.internet.url()
    return courtEntity
  }

  courtType: string = ''
  courts: number = 0
  distance: number = 0
  id: string = '-1'
  images: string[] = []
  latitude: number = 0
  longitude: number = 0
  name: string = ''
  address: string = ''
  rating: number = 0
  verified: boolean = false
  details = ''
  reviewCount = 0
  cost: string = 'Unknown'
  playLocation: string = 'Unknown'
  phone = ''
  website?: string = undefined
  hasMembership = false
  hasLighting = false
  privacyType = ''
  placeId?: string
}
